import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {DictionaryService, UserService} from "@amlCore/services";
import {IDictCountryItemType, IDictItemType} from "@amlCore/interfaces";
import {DossierAccessEnum} from "@amlCore/enums";
import {Subject} from "rxjs";
import {Utils} from "@amlCore/utils";
import {AlertPanelComponent, AlertPanelService, ICustomSelectMapper} from "@amlCore/components";
import {ActivatedRoute, Router} from "@angular/router";
import {CountryRiskService} from "./countryRisk.service";
import {RiskAccessEnum} from "../../../core/enum/riskAccessEnum";
import {CountryRiskModel} from "../../model/countryRisk.model";
import {CountryItemModel} from "../../../client";

@Component({
  selector: 'app-countryrisk',
  templateUrl: './countryRisk.component.html'
})
export class CountryRiskComponent implements OnInit, OnDestroy {
  submitted = false;
  isSaveForm = false; // Признак, что форма сохранена
  isLoaded = false; // Признак, что форма загружена
  isEdit = false; // Признак, что форма редактируется
  form: FormGroup;
  $destroy = new Subject();
  protected oksmList: CountryItemModel[] = [];
  countryData = [];
  countryMapper: ICustomSelectMapper;

  constructor(
    protected router: Router,
    protected alertPanelSrv: AlertPanelService,
    protected dictSrv: DictionaryService,
    private _route: ActivatedRoute,
    private countryRiskService: CountryRiskService,
    private _userSrv: UserService
  ) {
  }

  @ViewChild('alertObjSave') alertObjToSave: AlertPanelComponent;
  item: CountryRiskModel;
  id: string;

  isReadOnlyAccess = this._userSrv.getAccess(RiskAccessEnum.RISK_COUNTRIES).readOnly;

  ngOnInit(): void {
    this.form = this.countryRiskService.getForm();
    this._route.params.subscribe(params => {
      this.id = params.id;
      if(params.id){
        this.isEdit = true;
        this.loadCountryRisk();
      }
    });
    this.dictSrv.getRemoteData('oksm').then((result) => {
      this.oksmList = result;
      this.initModelCountry();
    });
    this.countryMapper = {
      toModel: this.countryMapperToModel.bind(this)
    } as ICustomSelectMapper;
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }

  loadCountryRisk(): void {
    this.countryRiskService.getCountryRiskById(this.id).subscribe(data => {
      this.updateForm(data);
    });
  }

  updateForm(data?: CountryRiskModel): void {
    if (data) {
      this.form.patchValue(data);
      this.item = data;
      this.initModelCountry()
    }
    if(this.isReadOnlyAccess){
      this.form.disable();
    } else{
      this.form.enable();
    }
  }

  save(): void {
    if (this.form.invalid) {
      this.submitted = true;
      this.alertObjToSave.open(this.alertPanelSrv.getErrorMsg('Необходимо заполнить обязательные поля'));
      return;
    }
    const editableData = Utils.clone(this.form.getRawValue());
    this.countryRiskService.saveCountryRisk(editableData).subscribe(data => {
      this.updateForm(data);
      this.form.markAsPristine();
      this.isSaveForm = true;
      this.alertObjToSave.open(this.alertPanelSrv.getSuccessMsg('Данные сохранены'));
    });
  }

  f(field: string) {
    return this.form.get(field);
  }


  initModelCountry(): void {
    if (this.f('countries').value) {
      const selectedCountriesList = [];
      this.f('countries')?.value?.forEach((currentItem: string) => {
        const selectedItem = this.oksmList.find((itemDict) => itemDict.kod === currentItem);
        if (selectedItem) {
          selectedCountriesList.push({kod: selectedItem.kod, name: selectedItem.name});
        }
      });
      this.countryData = selectedCountriesList;
    }
  }

  closeModalCountry(state: boolean): void {
    if (state) {
      this.f('countries').setValue(this.countryData.map((item) => {
        return item.kod;
      }));
      this.form.markAsDirty();
    }
  }

  countryMapperToModel(origin: IDictCountryItemType, isDictData: boolean): IDictCountryItemType {
    if (isDictData) {
      return {
        kod: origin.kod,
        name: origin.name
      };
    } else {
      return origin;
    }
  }
}






